import { ActivatedRouteSnapshot } from '@angular/router';
import { NcRouteData } from '../interfaces/nc-route.interface';

export function checkRouterChildsData(route: ActivatedRouteSnapshot & { data?: NcRouteData }, compareWith: (data: NcRouteData) => boolean) {
  if (compareWith(route.data)) {
    return true;
  }

  if (!route.firstChild) {
    return false;
  }

  return checkRouterChildsData(route.firstChild, compareWith);
}
